import { jsx as r } from "react/jsx-runtime";
import { Sparkles as f } from "lucide-react";
import { forwardRef as p } from "react";
import { B } from "./Button-icgr8OM9.js";
const c = {
  sm: "sm",
  md: "md"
}, u = {
  sm: "w-3 h-3",
  md: "w-3.5 h-3.5"
}, l = p(function({ onClick: a, busy: t, label: i, busyLabel: m, size: o = "sm", disabled: n = !1, className: s, ...e }, d) {
  return /* @__PURE__ */ r(
    B,
    {
      ref: d,
      type: "button",
      variant: "tertiary",
      size: c[o],
      onClick: a,
      loading: t,
      disabled: n,
      iconLeft: /* @__PURE__ */ r(f, { className: u[o], "aria-hidden": "true" }),
      "aria-busy": t || void 0,
      "data-ls-composite": "b-ai-button",
      className: s,
      ...e,
      children: t ? m : i
    }
  );
});
l.displayName = "BAiButton";
export {
  l as B
};
//# sourceMappingURL=BAiButton-CVwN6GeA.js.map
